import { types as t, flow } from 'mobx-state-tree';

import { withEnv } from 'models/withEnv';

export const SlackSettings = t
  .model('SlackSettings', {
    connected: false,
    scopes: t.array(t.string),
    userScopes: t.array(t.string),
    loaded: false,
  })
  .views(withEnv)
  .actions((self) => ({
    afterCreate() {
      self.getIsConnected();
    },
    getIsConnected: flow(function* () {
      const res = yield self.env.api.integrations.slackSettings();
      if (!res.error) {
        self.connected = res.data.connected;
        self.scopes = res.data.scopes;
        self.userScopes = res.data.userScopes;
      }
      self.loaded = true;
    }),
  }));
